import { __extends } from "tslib";
import React from 'react';
import { withTranslation } from 'react-i18next';
import classnames from 'classnames';
import throttle from 'lodash/throttle';
import { withMobileContext } from '../../../../Context';
import DraftOffsetKey from '@wix/draft-js/lib/DraftOffsetKey';
import { SketchPicker } from 'react-color';
import CloseBold from '../../../../Icons/CloseBold';
import { IconSize } from '../../../../Icons/IconWrap';
import s from './ColorPicker.scss';
var ColorPicker = /** @class */ (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.scrollContainerRef = React.createRef();
        _this.rootRef = React.createRef();
        _this.closeRef = React.createRef();
        _this.updateColorState = throttle(function (color, event) {
            var _a = _this.props, getEditorState = _a.getEditorState, setEditorState = _a.setEditorState, customStylesPlugin = _a.customStylesPlugin;
            var editorState = getEditorState();
            var newEditorState = customStylesPlugin.color.toggle(editorState, color.hex);
            setEditorState(newEditorState);
        }, 300, { leading: false });
        _this.outsideClickHandler = function (e) {
            if (!_this.rootRef.current) {
                return;
            }
            if (!_this.rootRef.current.contains(e.target)) {
                _this.props.onClose && _this.props.onClose(e);
            }
        };
        _this.handleClose = function (e) {
            _this.props.onClose && _this.props.onClose(e);
        };
        return _this;
    }
    ColorPicker.prototype.componentDidMount = function () {
        document.addEventListener('click', this.outsideClickHandler, true);
        // We focus something inside the picker to close the toolbar, this
        // remove the highlight which means you can see the color change "live"
        if (this.closeRef.current) {
            this.closeRef.current.focus();
        }
    };
    ColorPicker.prototype.componentWillUnmount = function () {
        if (this.outsideClickHandler && typeof document !== 'undefined') {
            document.removeEventListener('click', this.outsideClickHandler, true);
        }
    };
    ColorPicker.prototype.render = function () {
        var _a = this.props, toolbarEl = _a.toolbarEl, customStylesPlugin = _a.customStylesPlugin, getEditorState = _a.getEditorState;
        var editorState = getEditorState();
        var buttonRect = toolbarEl.getBoundingClientRect();
        var popupWidth = 225;
        var popupHeight = 290;
        // Default to near to toolbar
        var top = buttonRect.top + window.scrollY;
        var styles = {
            top: Math.max(0, top),
            left: Math.max(0, buttonRect.left - popupWidth / 2),
        };
        // Try and move it to the left of the block
        var selection = editorState.getSelection();
        var currentContent = editorState.getCurrentContent();
        var currentBlock = currentContent.getBlockForKey(selection.getStartKey());
        var offsetKey = DraftOffsetKey.encode(currentBlock.getKey(), 0, 0);
        var editorEl = toolbarEl.closest('.da-editor');
        if (editorEl) {
            var node = editorEl.querySelectorAll("[data-offset-key=\"" + offsetKey + "\"]")[0];
            if (node) {
                var blockRect = node.getBoundingClientRect();
                styles.left = Math.max(0, blockRect.left - popupWidth);
                styles.top = Math.max(0, blockRect.top - popupHeight);
            }
        }
        styles.top = styles.top + "px";
        styles.left = styles.left + "px";
        var pickerStyles = {
            default: {
                picker: {
                    padding: '20px 10px 0',
                },
            },
        };
        return (React.createElement("div", { ref: this.rootRef, style: styles, className: classnames(s['wrapper'], s['top']) },
            React.createElement("div", { className: s['inner'] },
                React.createElement("button", { ref: this.closeRef, className: s['close'], onClick: this.handleClose },
                    React.createElement(CloseBold, { size: IconSize.TINY, className: s['close-icon'] })),
                React.createElement(SketchPicker, { color: customStylesPlugin.color.current(getEditorState()), disableAlpha: true, onChange: this.updateColorState, styles: pickerStyles }))));
    };
    return ColorPicker;
}(React.Component));
export { ColorPicker };
export default withMobileContext(withTranslation()(ColorPicker));
//# sourceMappingURL=ColorPicker.js.map